import { SET_TAB_ACTION } from './actions.type';
import { SET_TAB } from './mutations.type';

export default {
  [SET_TAB_ACTION](context, mode) {
    context.commit(SET_TAB, mode);
  },
};
